import 'animate.css';
import WOW from 'wow.js';
const wow = new WOW();
wow.init();
